<style lang="stylus">
    .topbar-helpbox
        display flex
        justify-content center
        align-items center
        position relative
        height 100%
        // width 36px
        &.isPrivate
            padding-left 20px
        &.isTeamsApp
            margin-right 20px
        .topbar-icon
            position relative
            width 24px
            height 24px !important
            cursor pointer
            user-select none
            padding 0 !important

            .msg-icon-img.default
                display block
            .msg-icon-img.hover
                display none
            &:hover
                .msg-icon-img.hover
                    display block
                .msg-icon-img.default
                    display none
        .topbar-icon_app
            position relative
            width 32px
            height 32px
            margin-right -8px
            border-radius 4px
            cursor pointer
            display flex
            align-items center
            justify-content center
            &:hover
                background var(--bg-color-tabpanel-btn-hover)
            .help-icon-app
                width 24px
                height 24px
                svg
                    width 24px
                    height 24px
                    color: var(--svg-color-primary)
                    &.active
                        color var(--svg-color-active)
        .topbar-icon_app.active
            background rgba(1, 127, 255, .08)
            .msg-icon-img
                svg
                    color var(--themeColor)
        .help-icon
            .step-wrapper
                position absolute
                width 33px
                height 32px
                margin -6px
                z-index -1
                &::before
                    content ''
                    width 100%
                    height 100%
                    display block
                    background var(--color-white)
                    border-radius 6px
            .step-wrapper.shepherd-target
                background rgba(0,0,0,0.5)
        .msg-icon-img
            width 24px
            height 24px
            svg
                width 24px
                height 24px
                color #222
            &:hover
                svg
                    color var(--svg-color-active)
        .menu
            width 180px
            border-radius 6px
            box-shadow $box-shadow
            position absolute
            // right 7px
            // top $common-box-top
            background var(--bg-color-white)
            color black
            padding: 6px
            .menu-item
                display flex
                border-radius: 4px;
                align-items center
                width 100%
                height 40px
                cursor pointer
                user-select none
                &:hover{
                    background-color: $common-hover-color;
                }
                .menu-icon
                    width 20px
                    height 20px
                    color var(--svg-color-primary)
                    margin 10px 16px 10px 10px
                >img
                    width 20px
                    height 20px
                    margin 10px 16px 10px 10px
                p
                    font-size 14px
                    color var(--text-color-primary)
                    white-space nowrap
                    overflow hidden
                    text-overflow ellipsis

                .expand-icon
                    flex 1
                    margin-left 16px
                .menu-item-expand
                    position absolute
                    top 0
                    right 178px
                    background var(--bg-color-white)
                    border-radius 6px
                    box-shadow $box-shadow
                    padding 6px
                    p
                        height 40px
                        line-height 40px
                        padding 0 24px
                        border-radius 6px
                        &:hover
                            background-color $common-hover-color
                .menu-item-arrow
                    width 8px
                    height 8px
                    margin 0
                    margin-left auto
                    margin-right 8px
                    color var(--svg-color-gray-75)


        .tabs-help-guidebox
            width 275px
            padding 18px 24px
            background var(--bg-color-white)
            position absolute
            right -27px
            top 33px
            z-index 1
            border-radius 4px
            filter drop-shadow(2px 2px 6px #d9d9d9)
            &::after
                content ''
                position absolute
                right 30px
                top -16px
                border 6px solid transparent
                border-bottom-color #fff
                border-bottom-width 10px

            p
                text-align left

            .guidebox-title
                font-size 12px
                color #000
                font-weight 700
                margin-bottom 8px

            .guidebox-content
                font-size 12px
                color #000
                white-space break-spaces
                .guidebox-svg
                    vertical-align middle

            .guidebo-btn
                display inline-block
                padding 3px 8px
                background var(--themeColor)
                color #fff
                font-size 12px
                text-align center
                float right
                border-radius 2px
                margin-top 10px
                cursor pointer
                user-select none
</style>

<template>
    <div class="topbar-helpbox" v-if="!isPlugin" :class="{ isPrivate: isPrivate && isAdmin, isTeamsApp: isTeamsApp }" v-click-outside="closeShowMenu">
        <div
            id="help-dropmenu"
            class="help-icon"
            :class="{ 'topbar-icon_app': from === 'app', 'topbar-icon': from !== 'app', active: showHelpMenu }"
            data-locate="help"
            :content="$t('helpTitle')"
            v-tippy="{ placement: 'bottom' }"
        >
            <div v-if="from === 'app'" class="help-icon-app" @click="toggleShowMenu">
                <iconSymbol :name="showHelpMenu ? 'help-menu-active' : 'help-menu'" :class="showHelpMenu ? 'active' : ''" />
            </div>
            <div v-else class="msg-icon-img" @click="toggleShowMenu">
                <iconSymbol name="topbar_question" />
            </div>
            <div v-if="tipShow" class="tabs-help-guidebox">
                <p class="guidebox-title">小提示</p>
                <p class="guidebox-content">更多帮助教程在右上角的【帮助中心】</p>
                <div class="guidebo-btn" @click="isNewUser = false">我知道了</div>
            </div>
            <div v-if="showUserTaskTips && onUserTask" class="tabs-help-guidebox">
                <p class="guidebox-title">{{ "提示" }}</p>
                <p class="guidebox-content">{{ "新手任务可以在这里再次打开哦" }}</p>
                <div class="guidebo-btn" @click="closeUserTaskTips">我知道了</div>
            </div>
            <div class="step-wrapper" v-if="from === 'app'"></div>
        </div>
        <div class="menu" :style="{ top: menuTop, right: menuRight }" data-locate="helpmenu" v-if="showHelpMenu">
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'helpGuides' }"
                style="position: relative"
                :title="$t('optGuides')"
                @mouseenter="handleGuideMouseEnter"
                @mouseleave="handleGuideMouseLeave"
                v-if="internal"
            >
                <iconSymbol class="menu-icon" name="help-new-user-video" />
                <p>{{ $t("optGuides") }}</p>
                <iconSymbol class="menu-item-arrow" name="usermenu-arrow" />
                <div class="menu-item-expand" v-show="showGuideExpand">
                    <p v-if="!isWorkwx" @click="clickHelpMenu('starterGuide')" :title="$t('starterGuide')">{{ $t("starterGuide") }}</p>
                    <p @click="clickHelpMenu('video1')" :title="$t('video1')">{{ $t("video1") }}</p>
                    <!-- <p v-if="!isPrivate && onUserTask" @click="clickHelpMenu('userTask')" :title="$t('userTask')">{{ $t("userTask") }}</p> -->
                </div>
            </div>
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'helpGuides' }"
                :title="$t('starterGuide')"
                @click="clickHelpMenu('starterGuide')"
                v-if="!internal"
            >
                <iconSymbol class="menu-icon" name="help-new-user-video" />
                <p>{{ $t("starterGuide") }}</p>
            </div>
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'helpVideo' }"
                :title="$t('video2')"
                @click="clickHelpMenu('video2')"
                v-if="internal && !isWorkwx"
            >
                <iconSymbol class="menu-icon" name="help-video" />
                <p>{{ $t("video2") }}</p>
            </div>
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'funcTutorial' }"
                :title="$t('function1')"
                @click="clickHelpMenu('function1')"
                v-if="internal && !isWorkwx"
            >
                <iconSymbol class="menu-icon" name="help-func" />
                <p>{{ $t("function1") }}</p>
            </div>
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'newFunc' }"
                :title="$t('function2')"
                @click="clickHelpMenu('function2')"
                v-if="!isPrivate"
            >
                <iconSymbol class="menu-icon" name="help-newFunc" />
                <p>{{ $t("function2") }}</p>
            </div>
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'helpShortKey' }"
                :title="$t('hotkey')"
                @click="clickHelpMenu('hotkey')"
                v-if="!isPrivate"
            >
                <iconSymbol class="menu-icon" name="help-hotkey" />
                <p>{{ $t("hotkey") }}</p>
            </div>
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'helpOnlineSupport' }"
                :title="$t('onlineSupport')"
                @click="clickHelpMenu('onlineSupport')"
                v-if="(!isPrivate && internal) || (!internal && from != 'app')"
            >
                <iconSymbol class="menu-icon" name="help-customService" />
                <p>{{ $t("onlineSupport") }}</p>
            </div>
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'helpCenter' }"
                :title="$t('help')"
                @click="clickHelpMenu('help')"
                v-if="!isWorkwx"
            >
                <iconSymbol class="menu-icon" name="help-help" />
                <p>{{ $t("help") }}</p>
            </div>
            <div
                class="menu-item"
                :class="{ activeFunc: activeFunc == 'helpReportError' }"
                :title="$t('refeed')"
                @click="clickHelpMenu('refeed')"
                v-if="!isPrivate && !isTeamsApp"
            >
                <iconSymbol class="menu-icon" name="help-refeed" />
                <p>{{ $t("refeed") }}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class HelpMenu extends Vue {
        @Prop()
        userInfo;
        @Prop()
        from;

        showHelpMenu = false;
        guideTimer = null;
        showGuideExpand = false;
        get menuTop() {
            return window.name == "maxHome" ? "53px" : "38px";
        }
        get menuRight() {
            return this.from === "app" ? "-8px" : "7px";
        }
        get isNewUser() {
            return this.$store.state.isNewUser;
        }
        set isNewUser(newVal) {
            this.$store.commit("setState", {
                type: "isNewUser",
                data: newVal,
            });
        }
        get onUserTask() {
            return this.$store.state.publicStore.onUserTask;
        }
        get tipShow() {
            return this.$store.state.isNewUserVideo && this.isNewUser && this.internal;
        }
        get activeFunc() {
            // 新建页没有 ui 的全局 store
            return window.name == "maxHome" ? "" : this.$store.state.ui.activeFunc;
        }
        toggleShowMenu() {
            if (window.name !== "maxHome") {
                this.$store.commit("setStatus", {
                    type: "activeFunc",
                    data: "",
                });
            }
            if (this.showHelpMenu) {
                this.closeShowMenu();
            } else {
                this.openShowMenu();
            }
            if (this.from === "app") {
                this.sensors.track("QuestionMarkIcon", {
                    Catalogues: "toptoolbar",
                });
            }
        }
        openShowMenu() {
            this.showHelpMenu = true;
            this.$emit("openHelpMenu");
        }
        closeShowMenu() {
            this.showHelpMenu = false;
            this.$emit("closeHelpMenu");
            this.handleGuideMouseLeave();
        }
        showUserTaskTips = false;
        closeUserTaskTips() {
            let showTips = localStorage.getItem("hidden-userTaskTips");
            let listTips = showTips ? JSON.parse(showTips) : [];
            !listTips.includes(this.userInfo.user_id) && listTips.push(this.userInfo.user_id);
            localStorage.setItem("hidden-userTaskTips", JSON.stringify(listTips));
            this.showUserTaskTips = false;
        }
        clickHelpMenu(type) {
            this.$gaTrack("helpcenter_clickoptions", `type: ${type}`);
            let track = (type) => {
                this.sensors.track("clickGif", {
                    Catalogues: "helpcenter",
                    type,
                });
            };
            let url = "";
            switch (type) {
                case "starterGuide":
                    this.closeShowMenu();
                    if (!this.$validateLogin()) return;
                    if (window.name == "maxHome") {
                        // 新建文件并开启引导
                        this.$bus.$emit("publicNewFile");
                        localStorage.setItem("openWithGuide", "1");
                    } else {
                        this.$bus.$emit("showShepherd");
                    }
                    return;
                case "video1":
                    this.closeShowMenu();
                    if (this.from == "app") {
                        this.$bus.$emit("showVideo");
                        return;
                    }
                    let item = this.$store.state.newUserVideo;
                    let play = () => {
                        item = this.$store.state.newUserVideo;
                        this.$store.commit("playVideo", {
                            title: item.title,
                            src: item.attach,
                        });
                    };
                    if (item) {
                        play();
                    } else {
                        this.$edApi
                            .getVideo({
                                class_id: 4,
                                user_id: 0,
                                platform: 1,
                                product: 2,
                            })
                            .then((list) => {
                                this.$store.commit("setState", {
                                    type: "newUserVideo",
                                    data: list.filter((v) => v.title == "入门视频")[0],
                                });
                                play();
                            });
                    }
                    track("getting Started");
                    return;
                case "video2":
                    url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/video` : "https://www.edrawmax.cn/helpcenter/web/video";
                    track("video");
                    break;
                case "function1":
                    url = this.isPrivate
                        ? `${this.urls.helpcenterUrl}/help/web/video?class=basic`
                        : "https://www.edrawmax.cn/helpcenter/web/video?class=basic";
                    track("gif");
                    break;
                case "function2":
                    url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/releases` : "https://www.edrawmax.cn/helpcenter/web/releases";
                    if (!this.internal) {
                        url = "https://edrawmax.wondershare.com/whats-new.html";
                    }
                    window.open(url);
                    // if (this.from == "app") {
                    //     url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/releases` : "https://www.edrawmax.cn/helpcenter/web/releases";
                    //     if (!this.internal) {
                    //         url = "https://edrawmax.wondershare.com/whats-new.html";
                    //     }
                    //     window.open(url);
                    // } else {
                    //     this.$store.commit("setState", {
                    //         type: "showReleasesModal",
                    //         data: true,
                    //     });
                    // }
                    track("new");
                    return;
                case "hotkey":
                    this.$store.commit("setDialogState", {
                        type: "showDialog",
                        data: true,
                    });
                    this.$store.commit("setDialogState", {
                        type: "dialogType",
                        data: "Hotkey",
                    });
                    this.closeShowMenu();
                    track("hotkey");
                    return;
                case "onlineSupport":
                    this.$store.commit("openOnlineSupport", { internal: this.internal });
                    this.closeShowMenu();
                    track("online support");
                    return;
                case "help":
                    url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/home` : "https://www.edrawmax.cn/helpcenter/web/home";
                    if (!this.internal) {
                        url = "https://www.edrawsoft.com/guide/edrawmax-online/";
                    }
                    track("helpcenter");
                    break;
                case "refeed":
                    url = this.internal ? "https://support.qq.com/product/164328" : "https://www.edrawmax.com/feedback/web/help";
                    track("feedback");
                    break;
                case "userTask":
                    this.$bus.$emit("useUserTask");
                    track("userTask");
                    this.closeShowMenu();
                    return;
            }
            window.open(url);
            this.closeShowMenu();
        }
        handleGuideMouseEnter() {
            clearTimeout(this.guideTimer);
            this.showGuideExpand = true;
        }
        handleGuideMouseLeave() {
            this.guideTimer = setTimeout(() => {
                this.showGuideExpand = false;
            }, 150);
        }

        created() {}
        mounted() {
            let ts: any = this;
            this.$bus.$on("showUserTaskTips", () => {
                this.showUserTaskTips = true;
            });
            ts.$bus.$on("showHelpMenu", () => {
                this.openShowMenu();
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("showHelpMenu");
        }
    }
</script>
<i18n>
{
  "zh": {
    "helpTitle": "帮助",
    "onlineSupport":"在线客服",
    "optGuides": "新手教程",
    "starterGuide": "新手向导",
    "video1": "入门视频",
    "video2": "视频教程",
    "function1": "功能教程",
    "function2": "新功能",
    "hotkey": "快捷键",
    "help": "帮助中心",
    "refeed": "我要反馈",
    "userTask": "新手任务"
  },
  "en": {
    "helpTitle": "Help",
    "onlineSupport":"Online Support",
    "optGuides": "Operation Guide",
    "starterGuide": "Started Guide",
    "video1": "Getting Started Video",
    "video2": "Video Tutorial",
    "function1": "Function Tutorial",
    "function2": "What's New",
    "hotkey": "Hotkey Reference",
    "help": "Help Center ",
    "refeed": "Feedback",
    "userTask": "User Task"
  },
  "fr": {
    "helpTitle": "Aide",
    "onlineSupport":"Support en ligne",
    "optGuides": "Guide d'opération",
    "starterGuide": "Guide novice",
    "video1": "Vidéo de démarrage",
    "video2": "Vidéo tutoriel",
    "function1": "Tutoriel sur les fonctions",
    "function2": "Quoi de neuf",
    "hotkey": "Raccourci",
    "help": "Centre d'aide",
    "refeed": "Retour"
  },
  "de": {
    "helpTitle": "Hilfe",
    "onlineSupport":"Online-Hilfe",
    "optGuides": "Gebrauchsanleitung",
    "starterGuide": "Anfängerführung",
    "video1": "Einführungsvideo",
    "video2": "Video Anleitung",
    "function1": "Funktionstutorial",
    "function2": "Was neu ist",
    "hotkey": "Hotkey",
    "help": "Support-Center",
    "refeed": "Feedback"
  },
  "jp": {
    "helpTitle": "ヘルプ",
    "onlineSupport":"オンラインサポート",
    "optGuides": "操作ガイド",
    "starterGuide": "スタートガイド",
    "video1": "スタートガイド",
    "video2": "チュートリアル",
    "function1": "使い方とコツ",
    "function2": "新機能",
    "hotkey": "ショートカット",
    "help": "ヘルプセンター",
    "refeed": "フィードバック"
  },
  "es": {
    "helpTitle": "Ayuda",
    "onlineSupport":"Soporte en línea",
    "optGuides": "Manual de operaciones",
    "starterGuide": "Guía del novato",
    "video1": "Video de introducción",
    "video2": "Video Tutorial",
    "function1": "Tutorial de funciones",
    "function2": "Qué hay de nuevo",
    "hotkey": "Referencia de Hotkey",
    "help": "Centro de ayuda",
    "refeed": "Retroalimentación"
  },
  "pt": {
    "helpTitle": "Ajuda",
    "onlineSupport":"Suporte Online",
    "optGuides": "Guia de Operação",
    "starterGuide": "Guia Iniciado",
    "video1": "Vídeo de Introdução",
    "video2": "Vídeo Tutorial",
    "function1": "Tutorial de Função",
    "function2": "O que há de novo",
    "hotkey": "Referência de Tecla de Atalho",
    "help": "Centro de Ajuda",
    "refeed": "Feedback"
  },
  "it": {
    "helpTitle": "Aiuto",
    "onlineSupport":"Supporto Online",
    "optGuides": "Guida operativa",
    "starterGuide": "Guida per principianti",
    "video1": "Video per iniziare",
    "video2": "Tutorial Video",
    "function1": "Tutorial di Funzione",
    "function2": "Cosa nuova c'è ",
    "hotkey": "Riferimento Scorciatoie",
    "help": "Centro Assistenza",
    "refeed": "Feedback"
  },
  "tw": {
    "helpTitle": "幫助",
    "onlineSupport":"線上支援",
    "optGuides": "操作指引",
    "starterGuide": "新手嚮導",
    "video1": "入门视频",
    "video2": "绘图视频教程",
    "function1": "功能介绍",
    "function2": "新功能",
    "hotkey": "快速鍵",
    "help": "帮助中心",
    "refeed": "反馈社区"
  },
  "kr": {
    "helpTitle": "도움말",
    "onlineSupport":"온라인 지원",
    "optGuides": "운영 가이드",
    "starterGuide": "시작 가이드",
    "video1": "가이드 영상",
    "video2": "동영상 튜토리얼",
    "function1": "기능 튜토리얼",
    "function2": "업데이트 정보",
    "hotkey": "단축키",
    "help": "도움말",
    "refeed": "피드백"
  },
  "id": {
    "onlineSupport":"Dukungan Online",
    "optGuides": "Panduan operasi",
    "starterGuide": "Panduan Dimulai",
    "video1": "Video Memulai",
    "video2": "Tutorial Video",
    "function1": "Tutorial Fungsi",
    "function2": "Yang Baru",
    "hotkey": "Referensi Tombol Cepat",
    "help": "Pusat Bantuan ",
    "refeed": "Umpan Balik"
  }
}
</i18n>
